import React from "react";
import { Button, Col } from "reactstrap";
import { useAuth } from "../auth/AuthProvider";
import DataTable from "../components/Tables/DataTable";
import useGetDataRightsRequests from "./useGetDataRightsRequests";

function Status() {
  const { user, signIn, signOut, loginError } = useAuth();

  return (
    <React.Fragment>
      <section className="request">
        {user ? (
          <Dashboard user={user} signOut={signOut} />
        ) : (
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <h2>Welcome Branch and Call Center Employees</h2>
                <h4>Please log in to view status of requests</h4>
                <p>
                  Welcome to the California Consumer Privacy Act (CCPA) Request
                  Portal. Please login in to manage Data Rights Requests. Access
                  to this information is rights restricted. To request access,
                  please contact you manager.
                </p>
                <Button onClick={signIn} color="primary" size="lg" block>
                  Log In
                </Button>

                {loginError && (
                  <div className="text-danger my-3 font-weight-bold">
                    Error: {loginError}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </section>
    </React.Fragment>
  );
}

function Dashboard({ user, signOut }) {
  const { loading, dataRightsRequests, error } = useGetDataRightsRequests();

  return (
    <React.Fragment>
      <Col>
        <nav className="navbar navbar-light" style={{ background: "#e3f2fd" }}>
          <div className="navbar-brand">
            Welcome, {user.account.name} |
            <a role="button" className="btn btn-link" onClick={signOut}>
              Logout
            </a>
          </div>
          <div className="navbar-nav">
            <a className="nav-item nav-link active" href="/" target="_blank">
              Create a Request on Behalf of a Consumer
            </a>
          </div>
        </nav>

        {loading && "Loading..."}
        {error && "Error. Could not load data"}

        {dataRightsRequests.length > 0 ? (
          <DataTable items={dataRightsRequests} />
        ) : null}
      </Col>
    </React.Fragment>
  );
}

export default Status;
